import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Broadcast, Play, X } from "@phosphor-icons/react";

/**
 * Slim, non-intrusive live broadcast strip — appears on the Landing hero.
 * Surfaces the single highest-relevance live (or fallback-featured) video.
 * Dismissable per session.
 */
export default function LiveTVHeroStrip() {
  const [pick, setPick] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("iaam_livetv_strip_dismissed") === "1");

  useEffect(() => {
    if (dismissed) return;
    api.get("/live-tv/hero").then((r) => setPick(r.data || null)).catch(() => {});
  }, [dismissed]);

  if (dismissed || !pick) return null;

  const isLive = pick.is_live;

  return (
    <div
      className="relative border border-[#27272A] bg-[#0A0A0C] mb-8 overflow-hidden"
      style={{ borderTopColor: isLive ? "#E60012" : "#22D3EE", borderTopWidth: 2 }}
      data-testid="livetv-hero-strip"
    >
      <div className="flex items-center gap-4 px-4 py-3">
        <div className="flex items-center gap-2 shrink-0">
          <Broadcast
            size={14}
            weight={isLive ? "fill" : "regular"}
            style={{ color: isLive ? "#E60012" : "#22D3EE" }}
            className={isLive ? "pulse" : ""}
          />
          <span className="label-mono" style={{ color: isLive ? "#E60012" : "#22D3EE" }}>
            {isLive ? "LIVE NOW" : "FEATURED · LIVE TV"}
          </span>
        </div>
        <span className="text-zinc-600">·</span>
        <Link
          to="/live-tv"
          className="text-sm text-white hover:text-zinc-300 flex-1 truncate"
          data-testid="livetv-hero-strip-link"
        >
          {pick.title}
        </Link>
        <span className="label-mono hidden md:inline">{pick.channel_name.toUpperCase()}</span>
        <Link
          to="/live-tv"
          className="label-mono px-2 py-1 border border-[#E60012] text-[#E60012] hover:bg-[#E60012] hover:text-white transition-colors flex items-center gap-1"
          data-testid="livetv-hero-strip-cta"
        >
          <Play size={9} weight="fill" /> WATCH
        </Link>
        <button
          onClick={() => { setDismissed(true); sessionStorage.setItem("iaam_livetv_strip_dismissed", "1"); }}
          className="text-zinc-500 hover:text-white transition-colors"
          aria-label="Dismiss"
          data-testid="livetv-hero-strip-dismiss"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
